import React from 'react';
import { Reveal } from './Reveal';
import { PathThread } from './PathThread';
export function PostLaunchTruth() {
  return <section className="py-16 md:py-20 bg-paper-dark border-y border-gray-200 relative" data-id="element-405">
      <div className="absolute -top-12 left-1/2 -translate-x-1/2" data-id="element-406">
        <PathThread data-id="element-407" />
      </div>
      <div className="max-w-2xl mx-auto px-6 text-center" data-id="element-408">
        <Reveal data-id="element-409">
          <h2 className="text-2xl md:text-4xl font-serif text-navy mb-10 leading-tight" data-id="element-410">
            The book can look successful{' '}
            <span className="italic text-seaglass" data-id="element-411">
              and still feel underused
            </span>
          </h2>
        </Reveal>

        <Reveal delay={0.1} data-id="element-412">
          <div className="text-lg text-text-muted leading-relaxed space-y-5 mb-14" data-id="element-413">
            <p data-id="element-414">A serious nonfiction book is not a small thing.</p>
            <p data-id="element-415">
              It carries your thinking, stories, frameworks, language, point of
              view, and years of work most people never see.
            </p>
            <p data-id="element-416">So the problem is not that the book failed.</p>
            <p data-id="element-417">
              The book may have done its first job. It created credibility. It
              gave people a reason to trust you.
            </p>
            <p data-id="element-418">But credibility alone does not tell a reader what to do next.</p>
          </div>
        </Reveal>

        <Reveal delay={0.2} data-id="element-419">
          <div className="relative" data-id="element-420">
            <div className="w-10 h-0.5 bg-sand rounded-full mx-auto mb-7" data-id="element-421"></div>
            <p className="text-2xl md:text-3xl font-serif text-navy leading-snug" data-id="element-422">
              "The book may have worked. <br className="hidden md:block" data-id="element-423" />
              <span className="italic text-seaglass" data-id="element-424">
                The path after it may be what was missing.
              </span>
              "
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}